import CustomerList from 'layouts/customer/CustomerList.js';
import CustomerView from 'layouts/customer/CustomerView.js';
import ProtectedRoute from "routes/protectedRoutes.js";

const CustomerRoutes = [

    {
      route: "/customer/list/:pageNo",
      key: "manage-customer",
      component: <ProtectedRoute check="logout"><CustomerList /></ProtectedRoute>
    },
    {
        route: "/customer/view/:id",
        key: "customer-view",
        component: <ProtectedRoute check="logout"><CustomerView /></ProtectedRoute>
      }
  

  ];

export default CustomerRoutes;
 